import {
  Box,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
  Card,
  CardBody,
  SimpleGrid,
} from '@chakra-ui/react'
import { FiCheckCircle } from 'react-icons/fi'

export const WarehousePage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={7}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            📦 Склад
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Раздел для учёта материалов: что поступило, что зарезервировано, что
            выдано и что нужно докупить.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <Card>
            <CardBody>
              <Heading size="sm" mb={2}>Категории</Heading>
              <Text color="gray.600">Группы материалов (например: бетон, арматура, расходники).</Text>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Heading size="sm" mb={2}>Материалы</Heading>
              <Text color="gray.600">Справочник позиций с остатками и единицами измерения.</Text>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Heading size="sm" mb={2}>Резервы</Heading>
              <Text color="gray.600">Бронирование материалов под конкретные работы/объекты.</Text>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Heading size="sm" mb={2}>Движения</Heading>
              <Text color="gray.600">История операций: приход, выдача, списание, перемещение.</Text>
            </CardBody>
          </Card>
        </SimpleGrid>

        <Box>
          <Heading size="md" mb={3}>Логика работы склада (пошагово)</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Шаг 1: Добавьте категории и материалы в справочник.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Шаг 2: Зафиксируйте приход — материалы появляются в остатках.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Шаг 3: Создайте резерв под объект/задачу, чтобы не отдали материал в другое место.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Шаг 4: При фактической работе сделайте выдачу — остаток уменьшится.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Шаг 5: Отслеживайте движения и заявки на закупку для дефицитных позиций.</ListItem>
          </List>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Важные правила</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Сначала резерв, потом выдача — так проще контролировать фактический расход.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Не меняйте остатки «вручную в голове» — каждое изменение фиксируйте операцией.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Если раздел «Склад» не виден, значит функция не включена в тарифе или нет прав.</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
